import React from 'react';
import axios from 'axios';
import Files from 'react-files';
import FontAwesome from 'react-fontawesome';
import {
    Button, Checkbox, ControlLabel, Form, FormControl, FormGroup, HelpBlock, OverlayTrigger,
    Popover
} from "react-bootstrap";
import {withRouter} from "react-router-dom";

import Loading from "../../components/Loading/index";

class AwardForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            file: [],
            inProcess: false,
            loading: this.props.match.params.id ? true : false,
            values: {
                name: '',
                description: '',
                count: 0,
                moneyValue: 0,
                donatedBy: '',
                useAsAvatar: false
            },
            validation: {
                states: {
                    name : null,
                    count: null,
                    moneyValue: null,
                    file: null
                },
                messages: {
                    name: '',
                    count: '',
                    moneyValue: '',
                    file: ''
                }
            }
        };

        this.handleChangeName = this.handleChangeName.bind(this);
        this.handleChangeDescription = this.handleChangeDescription.bind(this);
        this.handleChangeDonatedBy = this.handleChangeDonatedBy.bind(this);
        this.handleChangeCount = this.handleChangeCount.bind(this);
        this.handleChangeMoneyValue = this.handleChangeMoneyValue.bind(this);
        this.handleChangeUseAsAvatar = this.handleChangeUseAsAvatar.bind(this);
        this.handleChangeImage = this.handleChangeImage.bind(this);
        this.handleClearImage = this.handleClearImage.bind(this);

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    componentDidMount() {
        if (this.props.sessionData && this.props.sessionData.accessToken) {
            this.getAward();
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.sessionData && nextProps.sessionData.accessToken) {
            this.getAward();
        }
    }


    getAward() {
        if (this.props.match.params.id) {
            let loginToken = this.props.sessionData.accessToken;
            let config = {
                headers: {
                    'Authorization': 'Bearer ' + loginToken
                }
            };
            axios.get(this.props.api.awards + "/" + this.props.match.params.id, config)
            .then((response) => {
                    this.setState({
                        values: {
                            ...response.data
                        },
                        loading: false
                    });
            }).catch((error) => {
                this.props.addNotification('error', error.response.status, 'Nepodařilo se načíst odměnu!');
                this.props.history.push('/awards');
                console.log("Axios error: ", error);
            });
        }
    }

    // Form Handles
    handleChangeName(event) {
        let name =  event ? event.target.value : this.state.values.name;

        let values = this.state.values;
        values.name = name;

        let validation = this.state.validation;
        validation.states.name = name === '' ? 'error' : 'success';
        validation.messages.name = name === '' ? 'Název nesmí být prázdný!' : '';

        this.setState({
            values,
            validation
        });
    }

    handleChangeDescription(event) {
        let description =  event ? event.target.value : this.state.values.description;

        let values = this.state.values;
        values.description = description;

        this.setState({
            values,
        });
    }

    handleChangeDonatedBy(event) {
        let donatedBy =  event ? event.target.value : this.state.values.donatedBy;

        let values = this.state.values;
        values.donatedBy = donatedBy;

        this.setState({
            values,
        });
    }

    handleChangeCount(event) {
        let count =  event ? event.target.value : this.state.values.count;

        let values = this.state.values;
        values.count = count;

        let validation = this.state.validation;
        validation.states.count = count === '' ? 'error' : 'success';
        validation.messages.count = count === '' ? 'Množství odměn nesmí být prázdné!' : '';

        this.setState({
            values,
            validation
        });
    }

    handleChangeMoneyValue(event) {
        let moneyValue =  event ? event.target.value : this.state.values.moneyValue;

        let values = this.state.values;
        values.moneyValue = moneyValue;

        let validation = this.state.validation;
        validation.states.moneyValue = moneyValue === '' ? 'error' : 'success';
        validation.messages.moneyValue = moneyValue === '' ? 'Cena nesmí být prázdná!' : '';

        this.setState({
            values,
            validation
        });
    }

    handleChangeUseAsAvatar(event) {
        let useAsAvatar =  event ? !this.state.values.useAsAvatar : this.state.values.useAsAvatar;

        let values = this.state.values;
        values.useAsAvatar = useAsAvatar;

        this.setState({
            values
        });
    }

    handleChangeImage(image) {
        let {file, values, validation} = this.state;

        if (image && image.length !== 0) {
            let file = image[0];
            let img = new Image();
            // let sizeLimit = this.props.size;
            let component = this;
            img.onload = function() {
                // let height = img.height;
                // let width = img.width;
                //
                // // dimension check
                // if (width !== sizeLimit.width || height !== sizeLimit.height) {
                //     file = [];
                //     values.awardBase64 = undefined;
                //     validation.states.file = 'error';
                //     validation.messages.file = 'Rozměry fotky neodpovídají daným omezením!';
                //     component.setState({
                //         file,
                //         values,
                //         validation
                //     });
                // } else {
                //     file = image;
                //     let reader = new FileReader();
                //     reader.onload = function () {
                //         values.awardBase64 = reader.result;
                //     };
                //     reader.readAsDataURL(file[0]);
                //     validation.states.file = 'success';
                //     validation.messages.file = '';
                //     component.setState({
                //         file,
                //         values,
                //         validation
                //     });
                // }

                file = image;
                let reader = new FileReader();
                reader.onload = function () {
                    values.awardBase64 = reader.result;
                };
                reader.readAsDataURL(file[0]);
                validation.states.file = 'success';
                validation.messages.file = '';
                component.setState({
                    file,
                    values,
                    validation
                });
            };
            let _URL = window.URL || window.webkitURL;
            img.src = _URL.createObjectURL(file);
        } else {
            if ((file && file.length !== 0) || (this.props.match.params.id && this.state.values.image)) {
                validation.messages.file = '';
                validation.states.file = 'success';
            }
            else {
                validation.messages.file = 'Musíte vložit obrázek!';
                validation.states.file = 'error';
            }
        }

        this.setState({
            values,
            validation
        })
    }

    handleClearImage() {
        let {values, file} = this.state;
        file = [];
        values.awardBase64 = undefined;
        this.setState({
            file,
            values
        });
        this.refs.file.removeFiles()
    }

    isValid() {
        this.handleChangeName();
        this.handleChangeCount();
        this.handleChangeMoneyValue();
        this.handleChangeImage();

        return Object.values(this.state.validation.states).indexOf('error') === -1;
    }

    handleSubmit(event){
        event.preventDefault();
        if (this.isValid()) {
            this.setState({inProcess: true});
            this.props.action(this.state.values);
        }
    }

    handleClose() {
        this.props.history.push('/awards');
    }

    render () {
        let {name, count, description, donatedBy, moneyValue, useAsAvatar} = this.state.values;
        let file = this.state.file;
        let {states, messages} = this.state.validation;
        let title = this.props.data ? this.props.title + ' ' + this.props.data.name : this.props.title;

        const popoverInfo = (
            <Popover id="popover-info" title="Omezení nahráveného obrázku">
                <p>Obrázek musí splňovat tyto omezení:</p>
                <ul>
                    <li><strong>Velikost</strong> musí být {this.props.size.width}x{this.props.size.height}</li>
                    <li><strong>Formát obrázku</strong> musí být PNG.</li>
                </ul>
            </Popover>
        );

        return (
            <div className="x-panel">
                <div className="x-title">
                    <h2>{title}</h2>
                    <div className="clearfix"/>
                </div>
                <div className="x-content">
                    {
                        this.state.loading ? <Loading/> :
                            <Form onSubmit={this.handleSubmit}>
                                <div className="col-lg-5 col-md-5 col-sm-5 col-xs-12">
                                    <FormGroup controlId="name" validationState={states.name}>
                                        <ControlLabel>Název <span className="required">*</span></ControlLabel>
                                        <FormControl type="text" value={name} onChange={this.handleChangeName}/>
                                        <FormControl.Feedback/>
                                        <HelpBlock>{messages.name}</HelpBlock>
                                    </FormGroup>
                                    <FormGroup controlId="count" validationState={states.count}>
                                        <ControlLabel>Množství odměn <span className="required">*</span></ControlLabel>
                                        <FormControl type="number" value={count}
                                                     onChange={this.handleChangeCount}/>
                                        <FormControl.Feedback/>
                                        <HelpBlock>{messages.count}</HelpBlock>
                                    </FormGroup>
                                    <FormGroup controlId="moneyValue" validationState={states.moneyValue}>
                                        <ControlLabel>Cena <span className="required">*</span></ControlLabel>
                                        <FormControl type="number" value={moneyValue}
                                                     onChange={this.handleChangeMoneyValue}/>
                                        <FormControl.Feedback/>
                                        <HelpBlock>{messages.moneyValue}</HelpBlock>
                                    </FormGroup>
                                    <FormGroup controlId="text" validationState={states.description}>
                                        <ControlLabel>Popis</ControlLabel>
                                        <FormControl componentClass="textarea" placeholder="" value={description}
                                                     onChange={this.handleChangeDescription}/>
                                        <FormControl.Feedback/>
                                        <HelpBlock>{messages.description}</HelpBlock>
                                    </FormGroup>
                                    <FormGroup controlId="donatedBy">
                                        <ControlLabel>Do soutěže věnoval</ControlLabel>
                                        <FormControl type="text" placeholder="Zadejte, kdo cenu do soutěže věnoval" value={donatedBy}
                                                     onChange={this.handleChangeDonatedBy}/>
                                        <FormControl.Feedback/>
                                    </FormGroup>
                                    <Checkbox value={useAsAvatar} checked={useAsAvatar} onChange={this.handleChangeUseAsAvatar}>
                                        použít jako avatara
                                    </Checkbox>
                                </div>
                                <div
                                    className="col-lg-5 col-md-5 col-sm-5 col-xs-12 col-lg-offset-1 col-md-offset-1 col-sm-offset-1">
                                    <FormGroup controlId="file" validationState={states.file}>
                                        <ControlLabel>Obrázek <span className="required">*</span></ControlLabel>
                                        <Files
                                            ref='file'
                                            className='files-dropzone-gallery-single'
                                            onChange={this.handleChangeImage}
                                            accepts={['image/png']}
                                            multiple={false}
                                            clickable
                                        >
                                            <FormControl.Feedback/>
                                            {
                                                file.length > 0
                                                    ? <div className='files-gallery-single'>
                                                        {file.map((file, index) =>
                                                            <img className='files-gallery-single-item'
                                                                 src={file.preview.url} alt='' key={file.id}/>
                                                        )}
                                                    </div>
                                                    : this.state.values.image ?
                                                    <img className='files-gallery-single-item'
                                                         src={`${__APIURL__}/${this.state.values.image}`} alt=''/>
                                                    : <div>Zde vložte obrázek</div>
                                            }
                                        </Files>
                                        <Button type='button' className="btn btn-danger"
                                                onClick={this.handleClearImage}>Smazat</Button>
                                        <OverlayTrigger trigger={['hover', 'focus']} placement="right"
                                                        overlay={popoverInfo}>
                                            <FontAwesome name="info-circle" tag="i" size="2x"/>
                                        </OverlayTrigger>
                                        <HelpBlock>{messages.file}</HelpBlock>
                                    </FormGroup>
                                </div>
                                <div className="clearfix"/>
                                <div className="ln-solid"/>
                                <FormGroup>
                                    <div className="col-md-offset-4">
                                        <Button className="btn-primary" type="button"
                                                onClick={this.handleClose}>Zpět</Button>
                                        <Button type="submit" className="btn btn-success">{this.props.button}</Button>
                                        {this.state.inProcess && <Loading/>}
                                    </div>
                                </FormGroup>
                            </Form>
                    }
                </div>
            </div>
        );
    }
}

export default withRouter(AwardForm);



/** WEBPACK FOOTER **
 ** ./src/containers/Awards/AwardForm.js
 **/